import { GenericObject } from '@synergy/models';

/**
 * Queued is not sent: a mail goes onto a queue and leaves the house later. The
 * history keeps the two apart, because a mail that never went out is exactly
 * what someone reading the history needs to see (#2155).
 */
export enum SentMessageStatus {
    Queued = 'queued',
    Sent = 'sent',
    Failed = 'failed',
}

export class SentMessage {
    public id!: number;
    public recipient!: string;
    public subject!: string;
    public status!: SentMessageStatus;
    public failureReason?: string;
    public attachmentNames: string[] = [];
    public queuedAt!: string;
    public sentAt?: string;

    public static fromPlainObject(object: GenericObject): SentMessage {
        const message = new SentMessage();

        message.id = object['id'];
        message.recipient = object['recipient'];
        message.subject = object['subject'];
        message.status = object['status'];
        message.failureReason = object['failureReason'] ?? undefined;
        message.attachmentNames = object['attachmentNames'] ?? [];
        message.queuedAt = object['queuedAt'];
        message.sentAt = object['sentAt'] ?? undefined;

        return message;
    }
}
